import { Personalization } from '../../types';
import { maximumMessageLength } from './constants';

export const remainingCharacters = (details: Personalization) => {
  const {
    messageLineOne = '',
    messageLineTwo = '',
    messageLineThree = '',
    messageLineFour = '',
    messageLineFive = '',
  } = details || {};

  const total = parseInt(maximumMessageLength) * 5;

  return (
    total -
    ((messageLineOne?.length ?? 0) +
      (messageLineTwo?.length ?? 0) +
      (messageLineThree?.length ?? 0) +
      (messageLineFour?.length ?? 0) +
      (messageLineFive?.length ?? 0))
  );
};

export const nextFocus = (e) => {
  if (e.keyCode === 13) {
    e.preventDefault();
    const form = e.target.form.elements;
    const elementIndex = Array.prototype.indexOf.call(form, e.target);
    form[elementIndex + 1].focus();
  }
};
